<template>
  <div>
    <div class="espacio"></div>

    <!-- Encabezado -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div v-if="mensajeDetalle"
               class="form-control is-invalid d-inline-block"
               style="width:auto">
            {{ mensajeDetalle }}
          </div>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Órganos y Sistemas">
  <AyudaAnatAten />
</Modal>

    <!--  DataTable  -->
    <DataTable
      :data="anatatens"
      :columns="columnas"
      idField="idAnatAten"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="estadoPermitido"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay registros de órganos y sistemas."
      @refresh="cargarDatos()"
      @edit="({ idAnatAten }) => abrirModalEditar(idAnatAten)"
    >
      <!-- Botón de ayuda -->
      <template #boton-ayuda>
        <button
          class="btn-help"
          type="button"
          title="Abrir ayuda de órganos y sistemas"
          @click="showModalHelp = true"
          aria-label="Abrir ayuda de órganos y sistemas"
        >
          <span class="material-symbols-outlined">help</span>
        </button>
      </template>
    </DataTable>

    <!--  Modal editar  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalAnatAtenLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalAnatAtenLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- Ícono y órgano -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <span class="material-symbols-outlined" style="font-size:64px;color:orange">
                    {{ datoAnatAten.icono }}
                  </span>
                </div>
                <div class="col-10">
                  <label class="form-label">Órgano/Sistema</label>
                  <input type="text" class="form-control"
                         :value="datoAnatAten.anatomiaNombre" disabled>
                </div>
              </div>
            </div>

            <!-- Observación con micrófono -->
            <div class="mb-3">
              <div class="row">
                <div class="col-12">
                  <label class="form-label">Observación</label>
                  <div class="textarea-container-mic d-flex align-items-stretch">
                    <textarea rows="2" class="form-control"
                              v-model="datoAnatAten.observacion"
                              style="text-transform:uppercase"
                              maxlength="250" required></textarea>
                    <div class="buttons-container-mic d-flex flex-column ms-2">
                      <button v-if="!isDictating" type="button"
                              class="btn btn-light" title="Iniciar Dictado"
                              @click="startDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:30px;color:orangered;cursor:pointer">mic_off</span>
                      </button>
                      <button v-else type="button"
                              class="btn btn-light" title="Finalizar Dictado"
                              @click="stopDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:30px;color:green;cursor:pointer">mic</span>
                      </button>
                      <button type="button" class="btn btn-light"
                              title="Reiniciar observación"
                              @click="limpiarObservacion()">
                        <span class="material-symbols-outlined"
                              style="font-size:30px">delete_forever</span>
                      </button>
                      <div class="flex-grow-1"></div>
                      <small class="text-muted mt-auto text-end">
                        {{ (datoAnatAten.observacion || '').length }} / 250
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Hallazgos patológicos -->
            <div class="container">
              <div class="row">
                <div class="col">
                  <h5>Hallazgos Patológicos</h5>
                  <select multiple size="4"
                          v-model="selectedTipo0"
                          class="form-control select-multiple">
                    <option v-for="option in optionsTipo0"
                            :key="option.idAnatOpcion"
                            :value="option.nombre">
                      {{ option.nombre }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mt-3 d-flex justify-content-center">
                <button type="button" class="btn btn-primary"
                        @click="registrarSeleccionados()">
                  Registrar
                </button>
              </div>
            </div>

          </div>

          <instrucciones-multi-select />

          <div class="modal-footer">
            <button v-if="btnCrear" type="button"
                    class="btn btn-light"
                    @click.prevent="guardarAnatAten()">
              <i class="material-icons"
                 style="font-size:32px;color:blue;cursor:pointer">save</i>
            </button>
            <button v-if="btnEditar" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarEditAnatAten()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaAnatAten          from '@/views/ayuda/AyudaAnatAten.vue'
import InstruccionesMultiSelect from '@/views/ayuda/InstruccionesMultiSelect.vue'
import DataTable              from '@/components/DataTable.vue'
import { validarForm }        from '@/modules/validacionesForms.js'
import SpeechDictation        from '@/modules/microfono.js'
import api                    from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal                   from 'sweetalert'

export default {
  name: 'AnatAten',
  components: { AyudaAnatAten, InstruccionesMultiSelect, DataTable },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
  },

  data() {
    return {
      anatatens:      [],
      datoAnatAten:   {},
      titulo:         '',
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      dictation:      new SpeechDictation(),
      isDictating:    false,
      mensajeDetalle: '',
      showModalHelp:  false,
      options:        [],
      optionsTipo0:   [],
      selectedTipo0:  [],

      columnas: [
        { field: 'anatomiaNombre', label: 'Órgano/Sistema' },
        { field: 'observacion',    label: 'Observación' },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },

  mounted() {
    this.cargarDatos()
  },

  methods: {
    //  Carga de datos
    cargarDatos() {
      api.get(`/vwanatatens/idatencion/${this.p_idAtencion}`)
        .then(response => { this.anatatens = response.data.reverse() })
        .catch(error   => console.error('Error cargando anatatens:', error))
    },

    fetchOptions() {
      if (!['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)) return
      api.get(`/vwanatopcions/idanatomia/${this.datoAnatAten.idAnatomia}`)
        .then(response => {
          this.options      = response.data
          this.optionsTipo0 = response.data.filter(o => o.tipo === 0)
        })
        .catch(error => console.error('Error fetching options:', error))
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoAnatAten,
        ['idAnatomia', 'observacion'],
        ['idAnatomia', 'observacion']
      )
    },

    //  CRUD
    async guardarAnatAten() {
      if (this.validarForm() !== 1) return
      try {
        this.datoAnatAten.idAtencion = this.p_idAtencion
        await api.post('/anatatens', this.datoAnatAten)
        closeModal('ventanaModal')
        swal('Correcto!', 'Registro creado exitosamente!', 'success')
        this.cargarDatos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditAnatAten() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/anatatens', this.datoAnatAten)
        closeModal('ventanaModal')
        swal('Correcto!', 'Registro actualizado exitosamente!', 'success')
        this.cargarDatos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async abrirModalEditar(idAnatAten) {
      if (!['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)) {
        this.mensajeDetalle = `La acción no está permitida porque el estado es ${this.p_estadoAtencion}.`
        return
      }
      this.modalWindow = true
      if (idAnatAten) {
        const { data } = await api.get(`/vwanatatens/${idAnatAten}`)
        this.datoAnatAten = data
      }
      this.titulo    = 'Órganos y Sistemas'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
      this.fetchOptions()
    },

    //  Hallazgos
    registrarSeleccionados() {
      const seleccionados = [...this.selectedTipo0]
      if (!seleccionados.length) return
      let obs = (this.datoAnatAten.observacion || '').trim()
      if (!obs || obs.toUpperCase() === 'SIN PATOLOGÍA') {
        this.datoAnatAten.observacion = seleccionados.join('; ')
        return
      }
      const obsUpper = obs.toUpperCase()
      const nuevos   = seleccionados
        .map(v => v.trim())
        .filter(v => !obsUpper.includes(v.toUpperCase()))
      if (nuevos.length) {
        this.datoAnatAten.observacion = obs + '; ' + nuevos.join('; ')
      }
    },

    limpiarObservacion() {
      this.datoAnatAten.observacion = ' '
    },

    //  Micrófono
    startDictation() {
      this.isDictating = true
      this.dictation.startDictation(
        transcript => { this.datoAnatAten.observacion = transcript },
        this.datoAnatAten.observacion
      )
    },
    stopDictation() {
      this.isDictating = false
      this.dictation.stopDictation()
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/tabla_estilizada.css" scoped></style>
<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.select-multiple { height: 200px; overflow-y: auto; }
.espacio         { margin-top: 0.25em; }
</style>